import { updateStore } from 'globals/coreStore';
import { syncHistoryFilterStore } from 'globals/chatHistoryStatusFilter';

import type { NormalizedStartParameters } from '../widget_api/types';

export const syncHistoryFilterStoreFromStartParameters = (
  startParameters: NormalizedStartParameters,
) => {
  syncHistoryFilterStore(updateStore, startParameters);
};
